import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import imgStar from './images/star.png'
import imgAvatar from './images/avatar.png'
import imgBtnCancel from './images/btn_cancel.png'
import imgBtnConfirm from './images/btn_confirm.png'
import imgAlipay from './images/alipay.png'
import imgWechat from './images/wechat.png'
import imgCheck from './images/check.png'
import imgChecked from './images/checked.png'
import imgBtnPay from './images/btn_pay.png'
import imgClear from './images/clear.png'
import { CenterPopup, Grid } from 'antd-mobile';
import { xslog } from './utils/XSLog';
import { Environment } from './utils/environment';
import { XsHttpCient } from './utils/HttpUtil';
import { notify } from './utils/NotifyUtil';
import { LOCALSTORAGE_KEY } from './Constrants';
import { doWechatAuth } from './utils/WechatAuth';
declare const WeixinJSBridge: any;
function App() {

  // "luckyNum": 11111111,
  // "image": "http://files.cijian.link/app/bg/11.png",
  // "nickName": "流水",
  // "sex": 0

  const [user, setUser] = useState(null);
  const inputRef = useRef(null);

  const [inputValue, setInputValue] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [inputValueError, setInputValueError] = useState(false);
  const [payMode, setPayMode] = useState(1);
  const [inputCusPriceValue, setInputCusPriceValue] = useState("");
  const [curPrice, setCurPrice] = useState("");
  const [pop, setPop] = useState(false);
  const [paypop, setpaypop] = useState(false);
  const inputGroupClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }
  const handleChange = (e) => {
    if (e.target.value.length <= 8) {
      const sanitizedValue = e.target.value.replace(/[^0-9]/g, "");
      setInputValue(sanitizedValue); // 只有在不超过上限时才更新输入值
    }
  };

  const handleBlur = (e) => {
    if (inputValue!==null && inputValue.length != 8) {
      setInputValueError(true)
    }
  };

  useEffect(() => {
    if (!pop) {
      window.scrollTo(0, 0)
    }
  }, [pop])

  useEffect(() => {
    if (inputValue != null) {

      if (inputValue.length == 8) {
        XsHttpCient.get(`/public/user/searchByLuckyNum?luckyNum=${inputValue}`).then((res) => {
          xslog("searchByLuckyNum result ", res);
          if (res.data.data === null || res.data.data === undefined || res.data.data.id === null) {
            setInputValueError(true)
          } else {
            saveUser(res.data.data)
          }

        }).catch((error) => {
          xslog(error)
          notify(error.msg);
        });
      } else {
        if (inputValueError) {
          setInputValueError(false)
        }
        saveUser(null)
      }
    }
  }, [inputValue])

  const handleCusPriceChange = (e) => {
    xslog('handleCusPriceChange' + e.target.value)

    var sanitizedValue = e.target.value.replace(/[^0-9]/g, "");
    if (sanitizedValue <= 0) {
      sanitizedValue = ''
    }
    if (sanitizedValue > 9999) {
      sanitizedValue = 9999
      notify('充值金额最高支持9999元哦')
    }
    setInputCusPriceValue(sanitizedValue); // 只有在不超过上限时才更新输入值

  };



  const saveUser = (u) => {
    setUser(u)
    if (u !== null && u !== undefined) {
      const ustr = JSON.stringify(u)

      xslog('saveUser user is ' + ustr);
      localStorage.setItem(LOCALSTORAGE_KEY.user, ustr)
    } else {
      xslog('saveUser clear');
      localStorage.setItem(LOCALSTORAGE_KEY.user, "")
    }
  }
  const [prices, setPrices] = useState([])

  useEffect(() => {


    xslog("init!!!!!!!!!!!!!!!!!!!!!")
    if (window.appEnvironment === Environment.WECHAT) {
      setPayMode(2)
    }

    const cache = sessionStorage.getItem('paycache');

    var fromSessionCachePrice = null;
    if (cache !== undefined && cache !== null && cache !== '') {
      const cd = JSON.parse(cache)
      setUser(cd.user)
      setInputValue("" + cd.user.luckyNum)
      if (cd.orderId !== undefined && cd.orderId !== null && cd.orderId !== '') {
        setOrderId(cd.orderId)
        setpaypop(true)
      }
      sessionStorage.removeItem('paycache');
      fromSessionCachePrice = cd.price;
    } else {
      var str = localStorage.getItem(LOCALSTORAGE_KEY.user);
      xslog('localStorage user is ' + str);
      if (str !== null && str !== undefined && str !== '') {
        const u = JSON.parse(str)
        setUser(u)
        setInputValue("" + u.luckyNum)
      }
    }

    XsHttpCient.get(`/public/pay/web/rechargePriceList`).then((res) => {
      xslog("searchByLuckyNum result ", res);

      setPrices(res.data.data)
      if (fromSessionCachePrice === null) {
        setCurPrice(res.data.data[1].productId)
      } else {
        if (fromSessionCachePrice.customPrice) {
          setPrices(prevItems =>
            prevItems.map(item =>
              item.customPrice === true ? { ...item, price: fromSessionCachePrice.price, times: fromSessionCachePrice.times } : item
            )
          );
        }

        setCurPrice(fromSessionCachePrice.productId)
      }

    }).catch((error) => {
      xslog(error)
      notify(error.msg);
    });


    const wxoauthBack = sessionStorage.getItem('wxoauth') === '1';

    xslog("wxoauthBack", wxoauthBack)
    if (wxoauthBack) {
      sessionStorage.removeItem('wxoauth')
      const params = new URLSearchParams(window.location.search);
      const isCallback = params.get('isCallback');
      const appId = params.get('appId');
      const timeStamp = params.get('timeStamp');
      const nonceStr = params.get('nonceStr');
      const packageV = params.get('package');
      const signType = params.get('signType');
      const paySign = params.get('paySign');
      xslog("wxoauthBack", isCallback, appId, timeStamp, nonceStr, packageV, signType, paySign)
      if (isCallback === 'true') {
        if (typeof WeixinJSBridge == "undefined") {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else {
          onBridgeReady();
        }
      }
    }

  }, [])

  const onPriceClick = (price) => {
    if (price.customPrice) {
      setPop(true)
    } else {
      setPrices(prevItems =>
        prevItems.map(item =>
          item.customPrice === true ? { ...item, price: 0, times: 0 } : item
        )
      );
      setCurPrice(price.productId)
    }

  }
  function onBridgeReady() {
    const params = new URLSearchParams(window.location.search);
    const appId = params.get('appId');
    const timeStamp = params.get('timeStamp');
    const nonceStr = params.get('nonceStr');
    const packageV = params.get('package');
    const signType = params.get('signType');
    const paySign = params.get('paySign');
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
      "appId": appId,     //公众号ID，由商户传入     
      "timeStamp": timeStamp,         //时间戳，自1970年以来的秒数     
      "nonceStr": nonceStr, //随机串     
      "package": packageV,
      "signType": signType,         //微信签名方式：     
      "paySign": paySign //微信签名 
    },
      function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          notify('您已充值成功！可在幸识app内使用啦')
        } else {
          notify('充值失败，请您重新支付')
        }
      });
  }
  const pay = () => {
    if (user === undefined || user === null) {
      notify("请输入正确的幸识号")
      return
    }

    var p = prices[0];
    prices.forEach((item) => {
      if (item.productId === curPrice) {
        p = item;
      }
    })

    if (payMode === 2) {
      const cache = {
        user: user,
        price: p
      }
      // 跳转前存储数据
      sessionStorage.setItem("paycache", JSON.stringify(cache));
      sessionStorage.setItem('wxoauth', '1');
      doWechatAuth(user.identity, p.productId, p.price);
    } else {
      XsHttpCient.post('public/pay/web/toOrder', { productId: p.productId, price: p.price, identity: user.identity, payType: payMode }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        xslog(res);
        const cache = {
          user: user,
          price: p,
          orderId: "" + res.data.data.orderId
        }
        // 跳转前存储数据
        sessionStorage.setItem("paycache", JSON.stringify(cache));
        window.location.href = res.data.data.url;
        setOrderId(res.data.data.orderId)
        setpaypop(true)
      }).catch((error) => {
        notify(error.msg)
      });
    }

  }

  const checkPayResult = () => {
    notify("orderId is " + orderId)
    setpaypop(false)
    XsHttpCient.get(`/public/pay/web/getOrderStatus?orderId=${orderId}`).then((res) => {
      if (res.data.data.status === 1) {
        notify("您已充值成功！可在幸识app内使用啦")
      } else {
        notify("充值失败，请您重新支付")
      }

    }).catch((error) => {
      xslog(error)
      notify(error.msg);
    });

  }

  const descText = () => {
    if (inputValueError) {
      return "请输入正确的幸识号"
    }
    if (user !== null) {
      return user.nickName
    }
    return '-';
  }

  const clearInput = () => {
    setInputValue("")
  }

  return (
    <div className="App" style={{ overflowY: 'auto' }}>
      <div style={{ width: 'calc(100% -20)', marginTop: 10, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flex: 'row', }}>
          <img src={imgStar} style={{ width: 25, height: 25, marginRight: 5 }} />
          <span style={{ fontSize: 18, color: '#2D2D2D' }}>幸识星充值</span>
        </div>

        <div onClick={inputGroupClick} style={{ marginTop: 15, width: '100%', height: 68, backgroundColor: '#FFFFFF', borderRadius: 10, position: 'relative', display: 'flex', flexDirection: 'row' }}>
          <img src={(user !== null) ? user.image : imgAvatar} style={{ borderRadius: '50%', width: 48, height: 48, margin: '10px 10px 0 15px' }} />
          <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', marginTop: 13 }}>
            <input onBlur={handleBlur} ref={inputRef} placeholder='请输入幸识号（在个人中心可查看）' maxLength={8}
              value={inputValue == null ? '' : inputValue} type='text' inputMode='numeric'
              onChange={handleChange} style={{ width: 'calc(100% - 48px)', height: 21, outline: 'none', border: 'none' }}></input>

            <span style={{ fontSize: 13, color: inputValueError ? '#FF5252' : '#C3C3C3', marginTop: 2, alignSelf: 'flex-start' }}>{descText()}</span>
          </div>
          {
            (inputValue != null && inputValue.length > 0 && user === null) ?
              <img src={imgClear} style={{ width: 24, height: 24, padding: 15, position: 'absolute', right: 0, top: 9 }} onClick={clearInput} /> : <></>}
          {
            (user != null) ?
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 38, padding: 15, position: 'absolute', right: 0, top: 0, fontSize: 13, color: '#4EA5E2' }} onClick={clearInput} >修改</div> : <></>}
        </div>

        <div style={{ marginTop: 15, width: '100%', height: 171, backgroundColor: '#FFFFFF', borderRadius: 10, position: 'relative', display: 'flex', flexDirection: 'row' }}>
          <Grid columns={3} style={{ margin: 15 }} gap={15}>
            {prices.map(item => (
              <Grid.Item key={prices.indexOf(item)} onClick={() => { onPriceClick(item) }}>
                <div style={{
                  height: 63, width: (window.innerWidth - 20 - 15 * 4) / 3, display: 'flex', flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center', backgroundColor: curPrice === item.productId ? '#EFF8FF' : '#F9F9F9', borderRadius: 7, border: curPrice === item.productId ? '1px #4EA5E2 solid' : '1px #F9F9F9 solid'
                }}>
                  {(item.customPrice && item.price <= 0) ?
                    <span style={{ fontSize: 13, color: '#A4A4A4' }}>自定义金额</span>
                    :
                    <>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ fontSize: 20, color: curPrice === item.productId ? '#4EA5E2' : '#A4A4A4' }}>{item.times}</span>
                        <img src={imgStar} style={{ width: 19, height: 19, opacity: curPrice === item.productId ? 1 : 0.5 }} />
                      </div>
                      <span style={{ fontSize: 11, marginTop: 3, color: curPrice === item.productId ? '#71BDF3' : '#A4A4A4' }}>{item.price / 100}元</span>
                    </>
                  }


                </div>
              </Grid.Item>
            ))}
          </Grid>

        </div>

        {window.appEnvironment === Environment.WECHAT ? <></> :
          <div style={{ marginTop: 15, width: '100%', backgroundColor: '#FFFFFF', borderRadius: 10, position: 'relative', display: 'flex', flexDirection: 'column' }}>
            <div onClick={() => { setPayMode(1) }} style={{ justifyContent: 'space-between', width: 'calc(100% - 30px)', padding: '15px 15px 7.5px 15px', display: 'flex', flexDirection: 'row' }}>
              <img src={imgAlipay} style={{ width: 95, height: 21 }} />
              <img src={payMode == 1 ? imgChecked : imgCheck} style={{ alignSelf: 'flex-end', width: 20, height: 20 }} />
            </div>

            <div onClick={() => { setPayMode(0) }} style={{ justifyContent: 'space-between', width: 'calc(100% - 30px)', padding: '7.5px 15px 15px  15px', display: 'flex', flexDirection: 'row' }}>
              <img src={imgWechat} style={{ width: 83, height: 21 }} />
              <img src={payMode == 0 ? imgChecked : imgCheck} style={{ width: 20, height: 20 }} />
            </div>

          </div>
        }


        <span onClick={()=>{
         window.location.href = 'https://www.cijianlink.com/pdu/webpay_recharge_agreement.html';
        }} style={{ fontSize: 11, color: '#C0C0C0', marginTop: 15 }}>充值代表已阅读同意<span style={{ color: '#4FA9F7' }}>《用户充值协议》</span></span>
        <img onClick={pay} src={imgBtnPay} style={{ width: window.innerWidth - 20, height: 60 * (window.innerWidth - 20) / 357 }} />
      </div>


      <CenterPopup className='Popup' maskStyle={{ opacity: 0.8 }} visible={pop} onClose={() => setPop(false)} onMaskClick={() => {
        setPop(false)
      }}>
        <div style={{ position: 'relative', width: window.innerWidth - 50, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} onClick={(e) => { e.stopPropagation(); }}  >
          <span style={{ color: '#515151', fontSize: 18, marginTop: 20 }}>自定义充值金额</span>
          <div style={{ display: 'flex', width: 'calc(100% - 40px)', flexDirection: 'row', alignItems: 'center', marginTop: 20 }}>
            <input placeholder='最低可充值1元，最高9999元'
              value={inputCusPriceValue}
              onChange={handleCusPriceChange} type='text' inputMode='numeric' style={{ flexGrow: 1, height: 41, paddingLeft: 10, outline: 'none', border: 'none', borderRadius: 10, backgroundColor: 'rgba(210, 207, 227, 0.15)' }}></input>
            <span style={{ fontSize: 15, margin: '0 5px 0 15px', color: '#515151' }}>元</span>
          </div>

          <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', margin: '25px 0 20px 0' }}>
            <img src={imgBtnCancel} style={{ width: 132.5, height: 41 }} onClick={() => { setPop(false) }} />
            <img src={imgBtnConfirm} style={{ width: 132.5, height: 41 }} onClick={() => {
              if (inputCusPriceValue !== null && inputCusPriceValue !== undefined && inputCusPriceValue !== '') {
                let c = parseInt(inputCusPriceValue);
                if (c > 0 && c <= 9999) {
                  setPrices(prevItems =>
                    prevItems.map(item =>
                      item.customPrice === true ? { ...item, price: c * 100, times: c * 100 } : item
                    )
                  );

                  prices.forEach(item => {
                    if (item.customPrice) {
                      setCurPrice(item.productId)
                    }
                  }
                  )
                  setInputCusPriceValue('')
                  setPop(false)
                }
              }

            }} />
          </div>
        </div>


      </CenterPopup>


      <CenterPopup className='Popup' maskStyle={{ opacity: 0.8 }} visible={paypop} onClose={() => setpaypop(false)} onMaskClick={() => {
        setpaypop(false)
      }}>
        <div style={{ position: 'relative', width: window.innerWidth - 50, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} onClick={(e) => { e.stopPropagation(); }}  >
          <span style={{ color: '#515151', fontSize: 18, marginTop: 20 }}>支付</span>

          <span style={{ color: '#515151', fontSize: 15, marginTop: 20 }}>支付中，请勿重复提交</span>

          <div style={{ display: 'flex', flexDirection: 'row', margin: '20px 0 20px 0' }}>
            <span onClick={() => { setpaypop(false) }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 132.5, height: 41, borderRadius: 40, border: '1px #DBDBDB solid', color: '#DBDBDB', fontSize: 15, marginRight: 20 }}>取消</span>

            <span onClick={checkPayResult} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 132.5, height: 41, backgroundColor: '#4FA9F7', borderRadius: 40, border: '1px #4FA9F7 solid', color: '#FFFFFF', fontSize: 15 }}>已支付</span>
          </div>
          <></>
        </div>


      </CenterPopup>


    </div>
  );
}

export default App;
